











































import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import ProductOffers from './ProductOffers.vue';
import Heading from './Heading.vue';
import AmazonImage from './AmazonImage.vue';
import AmazonProductDetailsModel from '../../models/ProductDetails';
import CanBeSizedMixin from '../../mixins/CanBeSizedMixin.vue';
import ScrollableMixin from '../../mixins/ScrollableMixin.vue';

@Component({
  components: {
    ProductOffers,
    AmazonImage,
    Heading,
  },
})
export default class ProductDetails extends mixins(CanBeSizedMixin, ScrollableMixin) {
  @Prop() private offer!: AmazonProductDetailsModel;

  get showPrice() {
    return this.offer.price != null && this.offer.price > 0;
  }

  get amazonImage() {
    return this.small ? this.offer.image.medium : this.offer.image.large;
  }

  get isLongTitle() {
    return this.offer.name.length > 60;
  }
  get usedText() {
    if (!this.offer.isUsed) {
      return '';
    }
    return 'Gebraucht für ';
  }
  get imageUnderTitle() {
    return this.isLongTitle || this.small;
  }

  get showStrikePrice() {
    return this.showPrice && this.offer.listPrice != null && this.offer.listPrice > this.offer.price;
  }

  get hasOffers() {
    return this.offer.offer != null;
  }

  get hasAvailability() {
    const best = this.offer.bestAvailability;
    return best != null;
  }

  get isPrime() {
    return this.hasOffers && this.offer.offer.amazonPrime;
  }
}
